import React, { useState } from 'react';
import ChatModule, { ChatMessage } from './ChatModule';
import { v4 as uuid } from 'uuid';
import AppBackButton from '../common/AppBackButton';

const ChatDemo: React.FC = () => {
  const [messages, setMessages] = useState<ChatMessage[]>([
    {
      id: uuid(),
      text: 'Hi! Feel free to test the chat.',
      sender: 'them',
      timestamp: Date.now() - 1000 * 60 * 5,
      avatarUrl: 'https://i.pravatar.cc/48?img=12',
    },
  ]);
  const [typing, setTyping] = useState(false);

  const simulateReply = (text?: string) => {
    setTyping(true);
    setTimeout(() => {
      setTyping(false);
      setMessages((m) => [
        ...m,
        {
          id: uuid(),
          text: `Echo: ${text || 'attachment received'}`,
          sender: 'them',
          timestamp: Date.now(),
          avatarUrl: 'https://i.pravatar.cc/48?img=12',
        },
      ]);
    }, 1200);
  };

  const onSend = async ({ text, file }: { text?: string; file?: File | null }) => {
    const id = uuid();
    // optimistic "sending" message
    setMessages((m) => [
      ...m,
      {
        id,
        text,
        fileUrl: file ? URL.createObjectURL(file) : undefined,
        fileName: file?.name,
        sender: 'me',
        timestamp: Date.now(),
        status: 'sending',
      },
    ]);

    // fake network
    await new Promise((r) => setTimeout(r, 700));

    // mark as sent
    setMessages((m) => m.map((msg) => (msg.id === id ? { ...msg, status: 'sent' } : msg)));

    // simulate partner reply
    simulateReply(text);
  };

  const onRetry = async (failed: ChatMessage) => {
    // Replace with real retry logic
    setMessages((m) =>
      m.map((msg) => (msg.id === failed.id ? { ...msg, status: 'sending' } : msg))
    );
    await new Promise((r) => setTimeout(r, 600));
    setMessages((m) => m.map((msg) => (msg.id === failed.id ? { ...msg, status: 'sent' } : msg)));
  };

  return (
    <div className="container my-4">
      <AppBackButton />
      <ChatModule
        title="Candidate Chat"
        meLabel="You"
        themLabel="Recruiter"
        messages={messages}
        typing={typing}
        onSend={onSend}
        onRetry={onRetry}
        allowAttachments
        height={520}
      />
    </div>
  );
};

export default ChatDemo;
